var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86549 7.81146H5.47318V14.4301C5.47318 14.5608 5.57906 14.6667 5.70974 14.6667H8.43565C8.56633 14.6667 8.67221 14.5608 8.67221 14.4301V7.84266H10.5204C10.6406 7.84266 10.7417 7.75248 10.7554 7.63311L11.0361 5.19647C11.0438 5.12944 11.0226 5.06229 10.9777 5.01199C10.9328 4.96166 10.8686 4.93284 10.8012 4.93284H8.67232V3.40542C8.67232 2.94499 8.92022 2.7115 9.40926 2.7115C9.47896 2.7115 10.8012 2.7115 10.8012 2.7115C10.9318 2.7115 11.0377 2.60557 11.0377 2.47494V0.238305C11.0377 0.107622 10.9318 0.0017474 10.8012 0.0017474H8.8829C8.86937 0.00108854 8.83933 0 8.79504 0C8.4622 0 7.30528 0.0653411 6.3914 0.906068C5.37882 1.83774 5.51959 2.95324 5.55322 3.14666V4.93278H3.86546C3.73478 4.93278 3.62891 5.03866 3.62891 5.16934V7.57488C3.62893 7.70553 3.73481 7.81146 3.86549 7.81146Z",
    fill: "#385C8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.3c80abe1.svg";
export { ForwardRef as ReactComponent };